import { connect } from 'react-redux'
import {
  setEmergencyContactFormField,
  setEmergencyContactForm
} from 'actions/account/emergencyContacts'

const mapStateToProps = ({ emergencyContacts: { form } }) => ({ form })

const actions = {
  setEmergencyContactFormField,
  setEmergencyContactForm
}

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
